<div
  stack-layout
  gap="md"
  paddingHorizontal="xl"
  paddingVertical="lg"
  [fullWidth]="true"
>
  @if (auth.isAuthenticated()) {
    <Text role="headline-large" display="block">{{ auth.userName() }}</Text>
    <Text>
      {{ auth.userEmail() }}
    </Text>

    <oui-divider border="medium" />
    <div row-layout alignItems="center" gap="md">
      <Text role="headline-small">Businesses: </Text>
      <Text>{{ auth.userBusinessEntitiesString() }}</Text>
    </div>

    <div row-layout alignItems="center" gap="md">
      <Text role="headline-small">Roles: </Text>
      <Text>{{ auth.userRolesString() }}</Text>
    </div>

    <oui-divider border="medium" />
    <div row-layout alignItems="center" gap="md">
      <Text role="headline-small">Theme: </Text>
      <oui-theme-switcher></oui-theme-switcher>
    </div>

    <oui-divider border="medium" />

    <div>
      <button
        text-button
        (click)="auth.signOut()"
        size="md"
        symbolRight="logout"
      >
        Sign out
      </button>
    </div>
  } @else {
    <div row-layout alignItems="center" gap="md">
      <Text role="headline-medium">Sign in to view profile.</Text>
      <button text-button (click)="auth.signIn()" size="md" symbolRight="login">
        Sign in
      </button>
    </div>
  }
</div>
